export var isPromise = function isPromise(p) {
  return p instanceof Promise;
};